import { useApi } from '@omnipresentgroup/api';
import type {
  GetContractorResponse,
  GetContractorResponseAPI,
} from '@omnipresentgroup/types';
import { useQuery } from '@tanstack/react-query';

import { API_BASE, API_PATH } from '../constants';
import { transformContractorFromAPI } from '../mappers';

export enum UserType {
  OP = 'op_id',
  INTERNAL = 'internal_id',
}

export const getContractorKey = (id: string) => {
  return [API_PATH, id];
};

export const useContractor = ({
  id,
  userType = UserType.INTERNAL,
  enabled,
}: {
  id: string;
  userType?: UserType;
  enabled?: boolean;
}) => {
  const { GET } = useApi();

  return useQuery<GetContractorResponseAPI, unknown, GetContractorResponse>({
    queryKey: [...getContractorKey(id), userType],
    queryFn: id
      ? () =>
          GET<GetContractorResponseAPI>(
            `${API_BASE}/${API_PATH}/${id}?id_type=${userType}`,
          )
      : () => Promise.reject(new Error('Invalid id to fetch a contractor')),
    enabled: !!id || enabled,
    select: transformContractorFromAPI,
  });
};
